import { PortalName } from '@/common/DataModel/PortalData';

interface LagoonItem {
  key: string;
  title: string;
  url: string;
}

export interface LagoonContainerConfigItem {
  key: string;
  value: string;
  id: string;
}

export const formatLagoonData = (
  data: LagoonItem[],
  sourceRecord: Record<string, string>
): Record<string, { title: string; url: string; testId: string }> => {
  return data?.reduce((acc, item) => {
    if (item.key in sourceRecord) {
      acc[item.key] = {
        title: item.title,
        url: item.url,
        testId: item.title.toLocaleLowerCase().split(' ').join('-'),
      };
    }
    return acc;
  }, {});
};

export const formatLagoonContainerConfigList = (
  configs: LagoonContainerConfigItem[] = []
): Record<string, LagoonContainerConfigItem> => {
  return configs?.reduce((acc, config) => {
    acc[config.key] = config;
    return acc;
  }, {});
};

export const filterAndFormatLagoonThemeConfigs = (
  configs?: Record<string, LagoonContainerConfigItem>
) => {
  return configs
    ? Object.entries(configs).reduce(
        (acc, [key, config]) => {
          if (key.startsWith('THEME_')) {
            const themeKey = key?.replace('THEME_', '');
            const portalName = themeKey?.toLowerCase() as PortalName;
            acc[portalName] = config;
          }
          return acc;
        },
        {} as Record<PortalName, LagoonContainerConfigItem>
      )
    : undefined;
};
